// ----------------------------------------------------------------------------
// Component: Featured Product
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import $ from "jquery";
import Swiper, {
    Navigation,
    A11y,
    Controller,
    FreeMode,
    Scrollbar,
    Keyboard,
} from "swiper";
import "snippets/card/card";
import "snippets/icon/icon";
import "snippets/background-media/background-media";
import "snippets/reviews/reviews";

// Styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/a11y";
import "swiper/css/scrollbar";
import "swiper/css/free-mode";
import "swiper/css/controller";
import "swiper/css/keyboard";
import "./_product-comparison.scss";

// -------------------------------------
// Variables
// -------------------------------------

// -------------------------------------
// Hooks
// -------------------------------------
function handleSlides(swiperEl) {
    swiperEl.slides.forEach(function (slide, index) {
        let slideLink = slide.querySelector("button");

        if (slideLink !== null) {
            slideLink.addEventListener("focus", function (e) {
                swiperEl.slideTo(index);
            });
        }
    });
}

function equalHeight(group) {
    var tallest = 0;

    group.each(function () {
        // Reset the height to get the original height of the element
        $(this).height("auto");

        // Get the actual height of the element
        var thisHeight = $(this).outerHeight();

        if (thisHeight > tallest) {
            tallest = thisHeight;
        }
    });

    group.outerHeight(tallest);
}

$(window).on("load", function () {
    $(".carousel--product-comparison__cards").each(function (index, element) {
        const $this = $(this),
            blocksSize = parseInt($this.attr("data-blocks-size"));

        // Generate unique class for each collection list slider
        $this.addClass("product-comparison__cards-instance-" + index);

        // Generate unique btn classes for slider arrows
        const prev_arrow = $this
            .parents(".product-comparison")
            .find(".swiper-button-prev");
        const next_arrow = $this
            .parents(".product-comparison")
            .find(".swiper-button-next");
        prev_arrow.addClass("product-comparison__cards-btn-prev-" + index);
        next_arrow.addClass("product-comparison__cards-btn-next-" + index);

        const cardsSwiper = new Swiper(
            ".product-comparison__cards-instance-" + index,
            {
                // Optional parameters
                modules: [Navigation, A11y, Controller, FreeMode, Keyboard],
                slidesPerView: blocksSize,
                spaceBetween: 20,
                observer: true,
                observeParents: true,
                a11y: false,
                watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
                freeMode: {
                    enabled: true,
                    momentum: true,
                },

                keyboard: {
                    enabled: true,
                    onlyInViewport: false,
                },

                breakpoints: {
                    // when window width is >= 680px
                    680: {
                        slidesPerView: blocksSize,
                        spaceBetween: blocksSize > 3 ? 20 : 100,
                    },
                },

                // // Navigation arrows
                navigation: {
                    nextEl: ".product-comparison__cards-btn-next-" + index,
                    prevEl: ".product-comparison__cards-btn-prev-" + index,
                },
            },
        );

        prev_arrow.on("keydown", function (e) {
            const key = e.key;

            if (key == "Enter") {
                cardsSwiper.slidePrev();
            }
        });

        next_arrow.on("keydown", function (e) {
            const key = e.key;

            if (key == "Enter") {
                cardsSwiper.slideNext();
            }
        });

        handleSlides(cardsSwiper);

        const quickLookContainer = $this
            .parents(".product-comparison")
            .find(".carousel--product-comparison__quick-look");
        quickLookContainer.addClass(
            "product-comparison__quick-look-instance-" + index,
        );

        const quickLookSwiper = new Swiper(
            ".product-comparison__quick-look-instance-" + index,
            {
                // Optional parameters
                modules: [A11y, FreeMode, Controller],
                slidesPerView: blocksSize,
                spaceBetween: 20,
                observer: true,
                observeParents: true,
                a11y: false,
                watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
                freeMode: {
                    enabled: true,
                    momentum: true,
                },

                breakpoints: {
                    // when window width is >= 680px
                    680: {
                        slidesPerView: blocksSize,
                        spaceBetween: blocksSize > 3 ? 20 : 100,
                    },
                },
            },
        );

        const benefitsContainer = $this
            .parents(".product-comparison")
            .find(".carousel--product-comparison__benefits");
        benefitsContainer.addClass(
            "product-comparison__benefits-instance-" + index,
        );
        benefitsContainer
            .find(".swiper-scrollbar")
            .addClass("product-comparison__benefits-scrollbar-" + index);
        const benefitsSwiper = new Swiper(
            ".product-comparison__benefits-instance-" + index,
            {
                // Optional parameters
                modules: [A11y, FreeMode, Controller, Scrollbar],
                slidesPerView: blocksSize,
                spaceBetween: 20,
                observer: true,
                observeParents: true,
                a11y: false,
                watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
                freeMode: {
                    enabled: true,
                    momentum: true,
                },

                breakpoints: {
                    // when window width is >= 680px
                    680: {
                        slidesPerView: blocksSize,
                        spaceBetween: blocksSize > 3 ? 20 : 100,
                    },
                },

                scrollbar: {
                    el: ".product-comparison__benefits-scrollbar-" + index,
                    draggable: true,
                },
            },
        );

        // Connect the 3 sliders
        cardsSwiper.controller.control = [quickLookSwiper, benefitsSwiper];
        quickLookSwiper.controller.control = cardsSwiper;
        benefitsSwiper.controller.control = cardsSwiper;

        // Equalize height for some elements across all columns
        const comparisonProductTitle = $this.find(
                ".product-comparison__product-title",
            ),
            quickLookDescription = quickLookContainer.find(
                ".quick-look__description",
            ),
            quickLookList = quickLookContainer.find(".quick-look__list");

        if (quickLookDescription.length) {
            equalHeight(quickLookDescription);
        }

        if (comparisonProductTitle.length) {
            equalHeight(comparisonProductTitle);
        }

        if (quickLookList) {
            quickLookList.find(".quick-look__item").each(function (index) {
                equalHeight(
                    quickLookList.find(`.quick-look__item:nth-child(${index})`),
                );
            });
        }
    });

    $(window).on("resize", function () {
        $(".carousel--product-comparison__cards").each(
            function (index, element) {
                const $this = $(this),
                    comparisonProductTitle = $this.find(
                        ".product-comparison__product-title",
                    ),
                    quickLookContainer = $this
                        .parents()
                        .find(".carousel--product-comparison__quick-look"),
                    quickLookDescription = quickLookContainer.find(
                        ".quick-look__description",
                    ),
                    quickLookList =
                        quickLookContainer.find(".quick-look__list");

                if (quickLookDescription.length) {
                    equalHeight(quickLookDescription);
                }

                if (comparisonProductTitle.length) {
                    equalHeight(comparisonProductTitle);
                }

                if (quickLookList) {
                    quickLookList
                        .find(".quick-look__item")
                        .each(function (index, element) {
                            equalHeight(
                                quickLookList.find(
                                    `.quick-look__item:nth-child(${index})`,
                                ),
                            );
                        });
                }
            },
        );
    });
});
